import { createSection, useRozeniteControlsPlugin } from "@-/com.npmjs.rozenite__controls-plugin";
import { useAdminControls } from "@-/dev.improve.haniverse.lib.admin.controls";
import { useMemo } from "react";

export function useNavRozeniteControls() {
  const { bundle, controls } = useAdminControls();

  const rozeniteControlSections = useMemo(
    () => [
      createSection({
        id: "han-runtime",
        items: [
          {
            id: "dev-bundle",
            title: "JavaScript bundle",
            type: "text",
            value: bundle,
          },
        ],
        title: "Haniverse",
      }),
      createSection({
        id: "haniverse-development",
        items: controls.flatMap((control) => [
          {
            description: control.description,
            id: `${control.id}-status`,
            title: `${control.title} status`,
            type: "text" as const,
            value: control.status,
          },
          {
            actionLabel: control.actionLabel,
            description: control.description,
            disabled: control.disabled,
            id: control.id,
            onPress: () => {
              void control.run();
            },
            title: control.title,
            type: "button" as const,
          },
        ]),
        title: "Development",
      }),
    ],
    [bundle, controls],
  );
  useRozeniteControlsPlugin({ sections: rozeniteControlSections });
}
